import { render, staticRenderFns } from "./NavBackButton.vue?vue&type=template&id=525e0576&scoped=true&"
import script from "./NavBackButton.vue?vue&type=script&lang=js&"
export * from "./NavBackButton.vue?vue&type=script&lang=js&"
import style0 from "./NavBackButton.vue?vue&type=style&index=0&id=525e0576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e0576",
  null
  
)

export default component.exports